import {
  Breadcrumb,
  Button,
  Card,
  Col,
  DatePicker,
  Empty,
  Form,
  Input,
  message,
  Pagination,
  Row,
  Select,
  Table,
} from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component, FormEvent } from 'react';
import { Query } from 'react-apollo';
import { Link } from 'react-router-dom';
import { orderManager } from 'src/services/order';
import { DateRange, PageInfo } from 'src/types/base';
import { mobileMasking, nameMasking } from 'src/utils/masking';
import * as xlsx from 'xlsx';

import { client } from '../../services/api';
import { noMaskingManager } from '../../services/noMasking';
import { ThirdPartyOrder } from '../../types/order';
import { THIRD_PARTY_ORDER_STATUS, THIRD_PARTY_PLATFORMS } from './type';

interface OrdersData {
  thirdPartyOrdersConnection: {
    pageInfo: PageInfo;
    nodes: ThirdPartyOrder[];
  };
}

interface Props {
  match: any;
  form: WrappedFormUtils;
}

// TODO (sunshaobin) graphql 分页后续需修改为每次查询累加的方式

// TODO (sunshaobin)  对于下载的操作也要加保护的措施，避免用户多次点击

export const thirdPartyOrdersQuery = gql`
  query getThirdPartyOrdersQuery(
    $platform: Int
    $status: Int
    $orderId: Int
    $originOrderId: String
    $paymentAtDateRange: DateRange
    $happenedAtDateRange: DateRange
    $take: Int
    $skip: Int
    $after: ID
    $before: ID
  ) {
    thirdPartyOrdersConnection(
      platform: $platform
      status: $status
      orderId: $orderId
      originOrderId: $originOrderId
      paymentAtDateRange: $paymentAtDateRange
      happenedAtDateRange: $happenedAtDateRange
      take: $take
      skip: $skip
      after: $after
      before: $before
    ) {
      pageInfo {
        totalCount
        startCursor
        endCursor
      }
      nodes {
        id
        originOrderId
        happenedAt
        orderId
        paymentAt
        platform
        raw
        status
        userId
      }
    }
  }
`;

interface State {
  selectedPlatform: string;
  selectedStatus: string;
  orderId: string;
  originOrderId: string;
  paymentAtDateRange: DateRange | undefined;
  happenedAtDateRange: DateRange | undefined;
  variables: Variables;
  currentPage: number;
}

interface Variables {
  platform?: number;
  status?: number;
  orderId?: number;
  originOrderId?: string;
  paymentAtDateRange?: DateRange | undefined;
  happenedAtDateRange?: DateRange | undefined;

  take: number;
  skip?: number;
  before?: number;
  after?: number;
}
const THIRD_PARTY_ORDERS_COUNT_PER_PAGE = 50;
export class OrderListForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedPlatform: '全部',
      selectedStatus: '全部',
      orderId: '',
      originOrderId: '',
      paymentAtDateRange: undefined,
      happenedAtDateRange: undefined,
      currentPage: 1,
      variables: {
        platform: 0,
        status: 0,
        skip: 0,
        take: THIRD_PARTY_ORDERS_COUNT_PER_PAGE,
      },
    };
    this.onResetClick = this.onResetClick.bind(this);
  }

  async exportExcel() {
    const status = this.getOrderSatus();
    const platform = this.getOrderPlatform();

    const response = await client.query<OrdersData>({
      query: thirdPartyOrdersQuery,
      variables: {
        platform,
        status,
        orderId: Number(this.state.orderId),
        originOrderId: this.state.originOrderId,
        happenedAtDateRange: this.state.happenedAtDateRange,
        paymentAtDateRange: this.state.paymentAtDateRange,
      },
    });

    const exportOrdersData = response.data.thirdPartyOrdersConnection.nodes;

    const exportExcelData = exportOrdersData.map(order => {
      const info = orderManager.getThirdPartyOrderInfo(order);

      const status = THIRD_PARTY_ORDER_STATUS.find(item => {
        return item.number === order.status;
      });

      const maskedMobile = mobileMasking(info && info.receiverMobile);
      const maskedReceiverName = nameMasking(info && info.receiverName);

      let maskedAddress = info && info.address;
      const province = info && info.province;
      const city = info && info.city;
      const isNoMasking = noMaskingManager.getNoMasking();
      if (maskedAddress && province && city && !isNoMasking) {
        const address = maskedAddress.slice(maskedAddress.length - 5);
        maskedAddress = `${province}${city}******${address}`;
      }

      return {
        order: order.id,
        orderId: order.orderId,
        originOrderId: order.originOrderId,
        platform: THIRD_PARTY_PLATFORMS[order.platform],
        receiverName: maskedReceiverName,
        receiverMobile: maskedMobile,
        tradeName: info && info.tradeName,
        totalPrice: info && info.totalPrice,
        status: status && status.name,
        paymentAt: `${moment(order.paymentAt).utcOffset(8).format('YYYY-MM-DD HH:mm:ss')}`,
        happenedAt: `${moment(order.happenedAt).utcOffset(8).format('YYYY-MM-DD HH:mm:ss')}`,
        province: info && info.province,
        city: info && info.city,
        address: maskedAddress,
      };
    });
    const workbook = xlsx.utils.book_new();
    const sheet1 = xlsx.utils.json_to_sheet(exportExcelData);
    xlsx.utils.book_append_sheet(workbook, sheet1);
    xlsx.writeFile(workbook, 'orders.xlsx');
  }

  search = (e: FormEvent) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        message.error(err);
        return;
      }
      const {
        paymentAtDateRange,
        happenedAtDateRange,
        selectedStatus,
        selectedPlatform,
        orderId,
        originOrderId,
      } = values;

      if (
        (paymentAtDateRange && moment(paymentAtDateRange.from).isAfter(paymentAtDateRange.to)) ||
        (happenedAtDateRange && moment(happenedAtDateRange.from).isAfter(happenedAtDateRange.to)) ||
        (happenedAtDateRange && paymentAtDateRange && moment(happenedAtDateRange.from).isAfter(paymentAtDateRange.to))
      ) {
        message.error('时间选择有错误！');
        return;
      }

      const status = this.getOrderSatus(selectedStatus);

      const platform = this.getOrderPlatform(selectedPlatform);

      this.setState({
        happenedAtDateRange,
        paymentAtDateRange,
        selectedStatus,
        selectedPlatform,
        orderId,
        originOrderId,
        currentPage: 1,
        variables: {
          platform,
          status,
          orderId,
          originOrderId,
          happenedAtDateRange,
          paymentAtDateRange,
          take: THIRD_PARTY_ORDERS_COUNT_PER_PAGE,
          skip: 0,
        },
      });
    });
  };

  getOrderSatus(selectedStatus?: string) {
    let newSelectedStatus = this.state.selectedStatus;
    if (selectedStatus) {
      newSelectedStatus = selectedStatus;
    }
    const status = 0;

    for (const item of THIRD_PARTY_ORDER_STATUS) {
      if (item.name === newSelectedStatus) {
        return item.number;
      }
    }
    return status;
  }

  onResetClick() {
    this.props.form.resetFields();
  }

  getOrderPlatform(selectedPlatform?: string) {
    let newSelectedPlatform = this.state.selectedPlatform;
    if (selectedPlatform) {
      newSelectedPlatform = selectedPlatform;
    }
    const platform = 0;
    for (const [index, item] of THIRD_PARTY_PLATFORMS.entries()) {
      if (item === newSelectedPlatform) {
        return index;
      }
    }
    return platform;
  }

  createTable() {
    const { variables, currentPage } = this.state;
    return (
      <Query<OrdersData> query={thirdPartyOrdersQuery} variables={this.state.variables}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const thirdPartyOrdersConnection = (data && data.thirdPartyOrdersConnection) || [];
          const { nodes: orders = [] } = thirdPartyOrdersConnection;

          const dataSource: {
            key: number;
            id: number;
            orderId?: number;
            platform: string;
            receiverName: string;
            receiverMobile: string;
            tradeName?: string;
            totalPrice?: number;
            status?: string;
            paymentAt: string;
            happenedAt: string;
          }[] = orders.map((order: ThirdPartyOrder) => {
            const info = orderManager.getThirdPartyOrderInfo(order);
            const maskedMobile = mobileMasking(info && info.receiverMobile);
            const maskedReceiverName = nameMasking(info && info.receiverName);

            const status = THIRD_PARTY_ORDER_STATUS.find(item => {
              return item.number === order.status;
            });

            return {
              key: order.id,
              id: order.id,
              orderId: order.orderId,
              originOrderId: order.originOrderId,
              platform: THIRD_PARTY_PLATFORMS[order.platform],
              receiverMobile: maskedMobile,
              receiverName: maskedReceiverName,
              tradeName: info && info.tradeName,
              totalPrice: info && info.totalPrice,
              status: status && status.name,
              paymentAt: `${moment(order.paymentAt).utcOffset(8).format('YYYY-MM-DD HH:mm:ss')}`,
              happenedAt: `${moment(order.happenedAt).utcOffset(8).format('YYYY-MM-DD HH:mm:ss')}`,
            };
          });
          return (
            <Table
              style={{ marginTop: '10px' }}
              loading={loading}
              size="small"
              pagination={false}
              footer={() => (
                <Pagination
                  style={{ float: 'right', marginBottom: 16 }}
                  total={
                    thirdPartyOrdersConnection &&
                    thirdPartyOrdersConnection.pageInfo &&
                    thirdPartyOrdersConnection.pageInfo.totalCount &&
                    thirdPartyOrdersConnection.pageInfo.totalCount
                  }
                  pageSize={variables.take}
                  current={currentPage}
                  onChange={nextPage => {
                    const pageSkip = (Math.abs(nextPage - currentPage) - 1) * THIRD_PARTY_ORDERS_COUNT_PER_PAGE;

                    if (nextPage > currentPage) {
                      this.setState({
                        variables: {
                          platform: this.getOrderSatus(),
                          status: this.getOrderSatus(),
                          orderId: Number(this.state.orderId),
                          originOrderId: this.state.originOrderId,
                          happenedAtDateRange: this.state.happenedAtDateRange,
                          paymentAtDateRange: this.state.paymentAtDateRange,
                          skip: pageSkip,
                          take: THIRD_PARTY_ORDERS_COUNT_PER_PAGE,
                          after: thirdPartyOrdersConnection.pageInfo.endCursor,
                        },
                      });
                    }
                    if (nextPage < currentPage) {
                      this.setState({
                        variables: {
                          platform: this.getOrderSatus(),
                          status: this.getOrderSatus(),
                          orderId: Number(this.state.orderId),
                          originOrderId: this.state.originOrderId,
                          happenedAtDateRange: this.state.happenedAtDateRange,
                          paymentAtDateRange: this.state.paymentAtDateRange,
                          skip: pageSkip,
                          take: THIRD_PARTY_ORDERS_COUNT_PER_PAGE,
                          before: thirdPartyOrdersConnection.pageInfo.startCursor,
                        },
                      });
                    }
                    this.setState({
                      currentPage: nextPage,
                    });
                  }}
                />
              )}
              columns={[
                {
                  title: 'ID',
                  key: 'id',
                  dataIndex: 'id',
                  width: '5%',
                },
                {
                  title: '订单编号',
                  key: 'orderId',
                  dataIndex: 'orderId',
                },
                {
                  title: '原始订单号',
                  key: 'originOrderId',
                  dataIndex: 'originOrderId',
                },
                {
                  title: '收件人',
                  key: 'receiverName',
                  dataIndex: 'receiverName',
                },
                {
                  title: '手机号码',
                  key: 'receiverMobile',
                  dataIndex: 'receiverMobile',
                },
                {
                  title: '商品名称',
                  key: 'tradeName',
                  dataIndex: 'tradeName',
                },
                {
                  title: '实付金额',
                  key: 'totalPrice',
                  dataIndex: 'totalPrice',
                },
                {
                  title: '状态',
                  key: 'status',
                  dataIndex: 'status',
                },
                {
                  title: '订单创建时间',
                  key: 'happenedAt',
                  dataIndex: 'happenedAt',
                },
                {
                  title: '订单支付时间',
                  key: 'paymentAt',
                  dataIndex: 'paymentAt',
                },
                {
                  title: '渠道',
                  key: 'platform',
                  dataIndex: 'platform',
                },
                {
                  title: '操作',
                  key: 'operation',
                  dataIndex: 'id',
                  render: (text, record) => {
                    return (
                      <Button type="primary">
                        <Link to={`/order/${record.id}`}>详情</Link>
                      </Button>
                    );
                  },
                },
              ]}
              dataSource={dataSource}
            />
          );
        }}
      </Query>
    );
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>订单列表</Breadcrumb.Item>
        </Breadcrumb>
        <Card title="订单管理">
          <Form onSubmit={this.search}>
            <Row gutter={24}>
              <Col xs={24} md={5} lg={4} xl={4} xxl={2} style={{ textAlign: 'right', marginTop: '10px' }}>
                订单渠道:
              </Col>
              <Col xs={24} md={15} lg={8} xl={8} xxl={4} style={{ marginTop: '10px' }}>
                <Form.Item>
                  {getFieldDecorator('selectedPlatform')(
                    <Select style={{ width: '100%' }} placeholder="选择渠道">
                      {THIRD_PARTY_PLATFORMS.map((thirdPartyPlatform, index) => {
                        return (
                          <Select.Option key={String(index)} value={thirdPartyPlatform}>
                            {thirdPartyPlatform}
                          </Select.Option>
                        );
                      })}
                    </Select>,
                  )}
                </Form.Item>
              </Col>

              <Col xs={24} md={5} lg={4} xl={4} xxl={2} style={{ textAlign: 'right', marginTop: '10px' }}>
                订单状态:
              </Col>
              <Col xs={24} md={15} lg={8} xl={8} xxl={4} style={{ marginTop: '10px' }}>
                <Form.Item>
                  {getFieldDecorator('selectedStatus')(
                    <Select placeholder="选择类型" style={{ width: '100%' }}>
                      {THIRD_PARTY_ORDER_STATUS.map(thirdPartyOrderStatus => {
                        return (
                          <Select.Option key={String(thirdPartyOrderStatus.number)} value={thirdPartyOrderStatus.name}>
                            {thirdPartyOrderStatus.name}
                          </Select.Option>
                        );
                      })}
                    </Select>,
                  )}
                </Form.Item>
              </Col>
              <Col xs={24} md={5} lg={4} xl={4} xxl={2} style={{ textAlign: 'right', marginTop: '10px' }}>
                订单编号:
              </Col>
              <Col xs={24} md={15} lg={8} xl={8} xxl={4} style={{ marginTop: '10px' }}>
                <Form.Item>{getFieldDecorator('orderId')(<Input allowClear placeholder="订单编号" />)}</Form.Item>
              </Col>
              <Col xs={24} md={5} lg={4} xl={4} xxl={2} style={{ textAlign: 'right', marginTop: '10px' }}>
                原始订单编号:
              </Col>
              <Col xs={24} md={15} lg={8} xl={8} xxl={4} style={{ marginTop: '10px' }}>
                <Form.Item>
                  {getFieldDecorator('originOrderId')(<Input allowClear placeholder="原始订单编号" />)}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24} style={{ marginTop: '10px' }}>
              <Col xs={5} md={5} lg={4} xl={3} xxl={3} style={{ textAlign: 'right', marginTop: '10px' }}>
                订单创建时间:
              </Col>
              <Col xs={19} md={19} lg={6} xl={7} xxl={7} style={{ marginTop: '10px' }}>
                <Form.Item>{getFieldDecorator('happenedAtDateRange')(<DatePicker.RangePicker />)}</Form.Item>
              </Col>
              <Col xs={5} md={5} lg={4} xl={3} xxl={3} style={{ textAlign: 'right', marginTop: '10px' }}>
                订单支付时间:
              </Col>
              <Col xs={19} md={19} lg={6} xl={7} xxl={7} style={{ marginTop: '10px' }}>
                <Form.Item>{getFieldDecorator('paymentAtDateRange')(<DatePicker.RangePicker />)}</Form.Item>
              </Col>
            </Row>
            <Row gutter={24} style={{ marginTop: '10px' }}>
              <Col xs={24} md={12} lg={6} xl={3} xxl={2} style={{ marginTop: '10px' }}>
                <Button
                  type="primary"
                  style={{ textAlign: 'right' }}
                  onClick={async () => {
                    await this.exportExcel();
                  }}
                >
                  导出订单
                </Button>
              </Col>
              <Col xs={24} md={12} lg={6} xl={3} xxl={2} style={{ marginTop: '10px' }}>
                <Button style={{ textAlign: 'right' }} type="primary">
                  导入发货
                </Button>
              </Col>
              <Col xs={24} md={12} lg={6} xl={3} xxl={2} style={{ marginTop: '10px' }}>
                <Button style={{ marginRight: 8 }} type="primary" onClick={this.onResetClick}>
                  重置
                </Button>
              </Col>
              <Col xs={24} md={12} lg={6} xl={3} xxl={2} style={{ marginTop: '10px' }}>
                <Button icon="search" type="primary" htmlType="submit">
                  搜索
                </Button>
              </Col>
            </Row>
          </Form>
          {this.createTable()}
        </Card>
      </>
    );
  }
}

export const OrderList = Form.create({ name: 'OrderList' })(OrderListForm);



// WEBPACK FOOTER //
// ./src/screens/order/OrderList.tsx